import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
    },
    section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
    },
    company_name: {
        Font:'Arial',
        fontWeight:900,
        fontSize:9
    },
    company_adress: {
        Font:'Arial',
        fontSize:8
    },
    paddingTop10:{
        paddingTop:10
    },
    cell: {
        marginRight:10,
        textAlign:"right"
    },
    tableRow:{
        display: 'flex',
        flexDirection: 'row',
    },
    col1:{
        display: 'flex',
        flexDirection: 'row',
        width:55
    },
    col2:{
        display: 'flex',
        flexDirection: 'row',
        width:30
    },
    col3:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col4:{
        display: 'flex',
        flexDirection: 'row',
        width:70
    },
    col5:{
        display: 'flex',
        flexDirection: 'row',
        width:70
    },
    floatright:{
        alignItems:"flex-end"
    },
    colComputations1:{
        width:255
    },
    colComputations2:{
        width:70
    },
    row:{
        display: 'flex',
        flexDirection: 'row',
    },
    textcenter:{
        textAlign:"center"
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize:6
    },
});

export function PdfDocument(props) {
    var duplicatePrint = [0,1];
    return (
        <Document>
            <Page size="Letter" style={styles.page} orientation="landscape" wrap>
                {duplicatePrint.map((row, ind) => 
                    <View style={styles.section}>
                        {/* HEADER SECTION DUBAI */}
                        {!props.headers.TRN == "" ? 
                            <View>
                                <Text style={styles.company_name}>TAX INVOICE</Text>
                                <Text style={styles.company_adress}>JCP Premiere General Trading LLC</Text>
                                <Text style={styles.company_adress}>TRN: {props.headers.TRN}</Text>
                                <Text style={[styles.company_name, styles.paddingTop10]}>Invoice No.: {props.headers.invoice_no}</Text>
                            </View>
                        : null} 
                        {/* HEADER SECTION */}
                        <Text style={styles.company_name}>{props.headers.companyname}</Text>
                        {/* Address */}
                        <Text style={styles.company_adress}>{props.headers.companyaddress}</Text>
                        {/* Contact No. and Website */}
                        <Text style={styles.company_adress}>{props.headers.companyphone +" | "+ props.headers.companywebsite}</Text>

                        {/* Activation No. */}
                        {!props.headers.idno == "" ? 
                            <Text style={styles.company_name}>ID#: {props.headers.idno}</Text>
                        : null} 

                        {/* Package Sales Information */}
                        {/* Atype */}
                        <Text style={[styles.company_name, styles.paddingTop10]}>Type:{props.headers.transactiontype}</Text>
                        {/* Date */}
                        <Text style={styles.company_name}>Date:{props.headers.date}</Text>
                        {/* Sold To */}
                        <Text style={styles.company_name}>Sold To:{props.headers.soldto}</Text>
                        {/* Package */}
                        <Text style={styles.company_name}>Package:{props.headers.package}</Text>
                        {/* Reference No. */}
                        <Text style={styles.company_name}>Reference No.:{props.headers.refno}</Text>
                        {/* Location */}
                        <Text style={styles.company_name}>Location:{props.headers.location}</Text>

                        {/* Item Details */}
                        <View style={[styles.tableRow,styles.paddingTop10]}>
                            <View style={[styles.tableRow,styles.col1]}>
                                <Text style={[styles.company_adress,styles.cell]}>Qty</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col2]}>
                                <Text style={[styles.company_adress,styles.cell]}>Unit</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col3]}>
                                <Text style={[styles.company_adress,styles.cell]}>Description</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col4]}>
                                <Text style={[styles.company_adress,styles.cell]}>Price</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col5]}>
                                <Text style={[styles.company_adress,styles.cell]}>Total</Text>
                            </View>
                        </View>
                        {!props.items == "" ? 
                            props.items.map((row, ind) => 
                                <View style={[styles.tableRow,styles.paddingTop10]}>
                                    <View style={[styles.tableRow,styles.col1]}>
                                    <Text style={[styles.company_adress,styles.cell]}>{props.items[ind].qty}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col2]}>
                                    <Text style={[styles.company_adress,styles.cell]}>{props.items[ind].unit}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col3]}>
                                        <Text style={[styles.company_adress,styles.cell]}>{props.items[ind].description}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col4]}>
                                        <Text style={[styles.company_adress,styles.cell]}>{props.items[ind].price}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col5]}>
                                        <Text style={[styles.company_adress,styles.cell]}>{props.items[ind].total}</Text>
                                    </View>
                                </View>
                            )
                        : null} 

                        {/* Computations */}
                        <View style={[styles.row,styles.paddingTop10]}>
                            <View style={[styles.floatright,styles.paddingTop10,styles.colComputations1]}>
                                {/* Total Amount */}
                                <Text style={styles.company_name}>Total Amount:</Text>
                            </View>
                            <View style={[styles.floatright,styles.paddingTop10,styles.colComputations2]}>
                                {/* Total Amount */}
                                <Text style={styles.company_name}>{props.computations.total_amount}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <View style={[styles.floatright,styles.colComputations1]}>
                                {/* Shippng/Freight */}
                                <Text style={styles.company_name}>Shipping/Freight:</Text>
                            </View>
                            <View style={[styles.floatright,styles.colComputations2]}>
                                {/* Shippng/Freight */}
                                <Text style={styles.company_name}>{props.computations.shippingfreight}</Text>
                            </View>
                        </View>
                        {!props.computations.discount == "" ?
                        <View style={styles.row}>
                            <View style={[styles.floatright,styles.colComputations1]}>
                                {/* Discount */}
                                <Text style={styles.company_name}>Discount:</Text>
                            </View>
                            <View style={[styles.floatright,styles.colComputations2]}>
                                {/* Discount */}
                                <Text style={styles.company_name}>{props.computations.discount}</Text>
                            </View>
                        </View>
                        : null} 
                        {!props.computations.netamount == "" ?
                        <View style={styles.row}>
                            <View style={[styles.floatright,styles.colComputations1]}>
                                {/* Net Amount */}
                                <Text style={styles.company_name}>Net Amount:</Text>
                            </View>
                            <View style={[styles.floatright,styles.colComputations2]}>
                                {/* Net Amount */}
                                <Text style={styles.company_name}>{props.computations.netamount}</Text>
                            </View>
                        </View>
                        : null}
                        {!props.computations.vatamount == "" ?
                        <View style={styles.row}>
                            <View style={[styles.floatright,styles.colComputations1]}>
                                {/* VAT Amount */}
                                <Text style={styles.company_name}>VAT Amount:</Text>
                            </View>
                            <View style={[styles.floatright,styles.colComputations2]}>
                                {/* VAT Amount */}
                                <Text style={styles.company_name}>{props.computations.vatamount}</Text>
                            </View>
                        </View>
                        : null}
                        <View style={styles.row}>
                            <View style={[styles.floatright,styles.colComputations1]}>
                                {/* Grand Total */}
                                <Text style={styles.company_name}>Grand Total:</Text>
                            </View>
                            <View style={[styles.floatright,styles.colComputations2]}>
                                {/* Grand Total */}
                                <Text style={styles.company_name}>{props.computations.grandtotal}</Text>
                            </View>
                        </View>

                        {/* Signature */}
                        <Text style={[styles.company_name,styles.paddingTop10]}>I hereby certify that I receive the items in good condition and complete quantity.</Text>
                        <Text style={[styles.company_name,styles.paddingTop10]}>Received By: __________________________  Received Date:_________.</Text>
                        <Text style={[styles.company_name,styles.paddingTop10]}>Prepared By: ___________. Checked By: _____________. Released By: _____________.</Text>
                        <Text style={styles.pageNumbers} render={({ pageNumber, totalPages }) => (
                            `Page ${pageNumber} | ${props.headers.trandate} - ${props.headers.trantime}`
                        )} />
                    </View>
                )}
            </Page>
        </Document>
    );
};